import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { userManagementReducer } from "./reducer";
import {
  assignGroupToUserAction,
  assignUsersToGroupAction,
  createUserAction,
  createUserGroupAction,
  getAllMenuListAction,
  getAllUserGroupsAction,
  getAssignedGroupToUserAction,
  getAssignedUsersToGroupAction,
  getSingleUserGroupDetailsAction,
  updateMenuListAction,
  updateUserGroupAction
} from "./actions";
import { UserManagementType } from "./userManagementTypes";

export const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: userManagementReducer,
  extraReducers: {
    [getAllMenuListAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [getAllMenuListAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      let sideMenu: any = [];
      let modules: any = [];
      let others: any = [];

      result?.length > 0 && result?.map((menu: any) => {
        menu?.category === 'side_menu' ? sideMenu.push(menu) :menu?.category === 'others'?others.push(menu):modules.push(menu)
      });

      return {
        ...state,
        fetching: false,
        menuList: result,
        statusCode: status_code,
        sideMenuList: sideMenu,
        moduleList: modules,
        othersList: others
      }
    },
    [getAllMenuListAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0
    }),
    [createUserGroupAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [createUserGroupAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code
      }
    },
    [createUserGroupAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    [assignGroupToUserAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [assignGroupToUserAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }
      return {
        ...state,
        success: 1,
        fetching: false,
        statusCode: status_code,
      }
    },
    [assignGroupToUserAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),

    [createUserAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [createUserAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
        }
      }
      return {
        ...state,
        success: 1,
        fetching: false,
        statusCode: status_code,
        createMenuMessage: result
      }
    },
    [createUserAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),

    [updateMenuListAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [updateMenuListAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code
      }
    },
    [updateMenuListAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0
    }),

    [updateUserGroupAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [updateUserGroupAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        createUserId: result
      }
    },
    [updateUserGroupAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0
    }),
    [getAllUserGroupsAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [getAllUserGroupsAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message ,count} = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        userGroupList: result,
        userGroupCount:count
      }
    },
    [getAllUserGroupsAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    [getAssignedGroupToUserAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [getAssignedGroupToUserAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        assignedGroupListCount: result?.total_count,
        assignedGroupList: result?.data
      }
    },
    [getAssignedGroupToUserAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    //below this  new assign group to user
    [getAssignedUsersToGroupAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [getAssignedUsersToGroupAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, status_code, message } = payload;
      
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        assignedUsersToGroupList: result
      }
    },
    [getAssignedUsersToGroupAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),

   [assignUsersToGroupAction.pending.toString()] : (state: UserManagementType) =>({
    ...state,
      fetching: true
   }),
   [assignUsersToGroupAction.fulfilled.toString()] : (state: UserManagementType, {payload}) =>{
    const { success, result, status_code, message } = payload;

    if (success === 0) {
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        error: message
      }
    }

    return {
      ...state,
      fetching: false,
      success,
      statusCode: status_code
    }
  }, 
  [assignUsersToGroupAction.rejected.toString()] : (state: UserManagementType,{error}) =>({
    ...state,
    fetching: false,
    error: error?.message,
    success: 0
   }),
//==============================================================
    [getSingleUserGroupDetailsAction.pending.toString()]: (state: UserManagementType) => ({
      ...state,
      fetching: true
    }),
    [getSingleUserGroupDetailsAction.fulfilled.toString()]: (state: UserManagementType, { payload }) => {
      const { success, result, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          success,
          error: message,
          statusCode: status_code,
          fetching: false
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        group_menu: result?.group_menu,
        group_name: result?.group_name,
        editUserGroupData: {
          group_menu: result?.group_menu,
          group_name: result?.group_name
        }
      }
    },
    [getSingleUserGroupDetailsAction.rejected.toString()]: (state: UserManagementType, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0
    })
  }
});

export const {
  resetSideMenuList,
  resetModulesList,
  resetUserManagementError,
  resetUserManagementFetching,
  resetUserManagementStatusCode,
  resetUserManagementSuccess,
  resetEditUserGroupData,
  resetUserGroupList,
  resetGroupMenu,
  resetGroupName,
  resetUserGroupCount,
  resetAssignedGroupListCount,
  resetOthersList
} = userManagementSlice.actions